import React from 'react';

import { Typography } from 'packages/common-frontend/components/Typography';
import { WorkflowTemplates } from 'packages/workflows/ui/WorkflowTemplates';
import { PermissionGuard } from '~/core/PermissionGuard';

export const FundingRequestContainer = () => {
  return (
    <PermissionGuard
      permissions={(context) =>
        context.flags
          .productsSettingsFundingRequestsInternalApprovalsPermissions
      }
      fallback={<Typography>No settings to configure.</Typography>}
    >
      <WorkflowTemplates
        workflowType="funding_requests"
        heading="Internal Approval Workflows"
        canMultipleTemplatesExist={false}
      />
    </PermissionGuard>
  );
};
